import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys } from '@askporter/query-keys';
import { IPAddressLocation } from '../types';

export const fetchIPAddressLocation = async (): Promise<IPAddressLocation | null> => {
  try {
    const ipApiResponse = await axios.get('https://ipapi.co/json');

    const ipData: IPAddressLocation = ipApiResponse.data;

    return ipData;
  } catch (err) {
    return null;
  }
};

export const useIPAddress = (): UseQueryResult<IPAddressLocation | null, Error> => {
  const query = useQuery({ queryKey: queryKeys.misc.ipLookup.all, queryFn: fetchIPAddressLocation });
  return query;
};
